import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getUserGroups, setUserGroups } from 'actions';
import { Table, Spinner, Button, Modal, Form, Alert, ListGroup } from 'react-bootstrap';

class UserGroupList extends Component {
  state = {
    showModal: false,
    formData: {
      group_name: '',
      description: '',
      is_active: true
    },
    error: null,
    showPermissionModal: false,
    selectedPermissions: [],
    selectedGroupName: ''
  };

  componentDidMount() {
    this.props.getUserGroups();
  }

  handleShowModal = () => {
    this.setState({ showModal: true, formData: { group_name: '', description: '', is_active: true }, error: null });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false, error: null });
  };

  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState(prev => ({
      formData: {
        ...prev.formData,
        [name]: type === 'checkbox' ? checked : value
      }
    }));
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { group_name, description, is_active } = this.state.formData;
    if (!group_name.trim()) {
      this.setState({ error: 'Group name is required' });
      return;
    }
    try {
      await this.props.setUserGroups([{ group_name, description, is_active, permissions: [] }]);
      this.handleCloseModal();
      this.props.getUserGroups();
    } catch (err) {
      this.setState({ error: err.message || 'Failed to create group' });
    }
  };

  handleShowPermissionModal = (permissions, groupName) => {
    this.setState({ showPermissionModal: true, selectedPermissions: permissions, selectedGroupName: groupName });
  };

  handleClosePermissionModal = () => {
    this.setState({ showPermissionModal: false, selectedPermissions: [], selectedGroupName: '' });
  };

  render() {
    const { userGroups, loading } = this.props;
    const { showModal, formData, error, showPermissionModal, selectedPermissions, selectedGroupName } = this.state;
    return (
      <div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3>User Groups</h3>
          <Button variant="primary" onClick={this.handleShowModal}>Create New Group</Button>
        </div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Group Name</th>
              <th>Permissions</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {userGroups.map((g) => (
              <tr key={g._id}>
                <td>{g.name || g.group_name}</td>
                <td>{g.permissions && g.permissions.length > 0 ? g.permissions.length : 0}</td>
                <td>
                  <Button
                    size="sm"
                    variant="info"
                    onClick={() => this.handleShowPermissionModal(g.permissions || [], g.name || g.group_name)}
                  >
                    View Permissions
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Modal show={showModal} onHide={this.handleCloseModal} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>Create New Group</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {error && <Alert variant="danger">{error}</Alert>}
            <Form onSubmit={this.handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Group Name</Form.Label>
                <Form.Control
                  name="group_name"
                  value={formData.group_name}
                  onChange={this.handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  name="description"
                  value={formData.description}
                  onChange={this.handleChange}
                  as="textarea"
                  rows={2}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="Active"
                  name="is_active"
                  checked={formData.is_active}
                  onChange={this.handleChange}
                />
              </Form.Group>
              <Button type="submit" variant="primary">Create</Button>
            </Form>
          </Modal.Body>
        </Modal>
        <Modal show={showPermissionModal} onHide={this.handleClosePermissionModal} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>Permissions of {selectedGroupName}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedPermissions.length === 0 ? (
              <div>No permissions.</div>
            ) : (
              <ListGroup>
                {selectedPermissions.map((perm, idx) => (
                  <ListGroup.Item key={idx}>
                    <b>{idx + 1}.</b> {perm}
                  </ListGroup.Item>
                ))}
              </ListGroup>
            )}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userGroups: state.userGroupReducer.userGroups || [],
  loading: state.userGroupReducer.loading
});

export default connect(mapStateToProps, { getUserGroups, setUserGroups })(UserGroupList); 